import React, { useState, useEffect } from 'react';
import { isAndroid, isIOS } from 'react-device-detect';
import PwaPrompt from 'react-ios-pwa-prompt';
import { useTranslation } from 'react-i18next';

import Button from '../button';
import './pwa-prompt.css';

const PwaInstallPrompt = () => {
    const { t } = useTranslation();
    const [installPrompt, setInstallPrompt] = useState(null);
    const [isVisible, setVisible] = useState(false);

    useEffect(() => {
        // Logic for Android PWA installation
        const handleBeforeInstallPrompt = (event) => {
            event.preventDefault();
            setInstallPrompt(event);
            if (event) {
                setVisible(true);
            }
        };

        if (isAndroid) {
            window.addEventListener('beforeinstallprompt', handleBeforeInstallPrompt);
        }

        return () => {
            if (isAndroid) {
                window.removeEventListener('beforeinstallprompt', handleBeforeInstallPrompt);
            }
        };
    }, []);

    const handleAndroidInstall = () => {
        if (!installPrompt) return;
        installPrompt.prompt();
        installPrompt.userChoice.then((choiceResult) => {
            if (choiceResult.outcome === 'accepted') {
                console.log('User accepted the install prompt');
            } else {
                console.log('User dismissed the install prompt');
            }
            setInstallPrompt(null);
            setVisible(false);
        });
    };

    const handleClose = () => {
        setVisible(false);
    };

    // Render nothing if not on a supported mobile device or prompt is not available/closed
    if (!isVisible && !isIOS) return null;

    if (isAndroid && isVisible) {
        return (
            <div className="pwa-prompt-container">
                <div className="pwa-prompt-content">
                    <p>{t('pwa.install_app')}</p>
                    <div className="pwa-prompt-buttons">
                        <Button title={t('pwa.install')} click={handleAndroidInstall} />
                        <button className="pwa-close-button" onClick={handleClose}>{t('pwa.later')}</button>
                    </div>
                </div>
            </div>
        );
    }

    if (isIOS) {
        return (
            <PwaPrompt
                promptOnVisit={1}
                timesToShow={3}
                copyTitle={t('pwa.ios.title')}
                copyBody={t('pwa.ios.body')}
                copyShareButtonLabel={t('pwa.ios.share_button')}
                copyAddHomeButtonLabel={t('pwa.ios.add_home_button')}
                copyClosePrompt={t('pwa.later')}
                permanentlyHideOnDismiss={false}
            />
        );
    }

    return null;
};

export default PwaInstallPrompt;
